module.exports = __webpack_public_path__ + "static/media/Bandit.b6417971.png";